/**
 * KeyboardShortcutsButton Component
 * Button to open keyboard shortcuts panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Keyboard } from 'lucide-react';

export const KeyboardShortcutsButton = ({ setShowKeyboardShortcuts }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowKeyboardShortcuts(true)}
    className="text-zinc-400 hover:text-white p-2"
    data-testid="keyboard-shortcuts-btn"
    title="Keyboard Shortcuts (?)"
  >
    <Keyboard className="w-5 h-5" />
  </Button>
);

export default KeyboardShortcutsButton;
